/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBattleStation = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M5 6.455 12 3l7 3.455v4.181c0 4.794-2.7 9.276-7 10.364-4.3-1.088-7-5.57-7-10.364zm2 7.584 4.23-1.27v2.539l-1.153 1.269V17L12 16.577l1.923.423v-.423l-1.154-1.27V12.77L17 14.04v-.847l-4.23-2.961V7.692C12.77 7.111 12.384 6 12 6s-.77 1.11-.77 1.692v2.539L7 13.192z" clipRule="evenodd" /></svg>;
export default SvgBattleStation;